var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('jz-card',{staticClass:"update-notification"},[_vm._v("TerraTalk v4.0.1がリリースされました。v4.0.0のままでは一部ご利用いただけない機能がありますので、App Storeから更新を行ってください。")])}
var staticRenderFns = []

export { render, staticRenderFns }